import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react'
import Formulaire from '../../../ModelesPages/Modele1/Formulaire_enseignant'
import { useAuth } from '../../../../ContextApp/AuthContext';
function Insertion(){
    const {user}=useAuth()
    const [adresse,setAdresse]=useState("");
    const [Count,setCount]=useState(0);
    const [lieu_naissance,setLieu_naissance]=useState("")
    const [date_naissance,setDate_naissance]=useState("")
    const [date_engagement,setDate_engagement]=useState("")
    const [email,setEmail]=useState("");
    const [errors,setErrors]=useState([]);
    const [nom,setNom]=useState("");
    const [postnom,setPostnom]=useState("");
    const [prenom,setPrenom]=useState("");
    const [sexe,setSexe]=useState("");
    const [niveau,setNiveau]=useState("");
    const [telephone,setTelephone]=useState("");
    const [message,setMessage]=useState("")
    const [nom_complet,setNom_complet]=useState("")
    const [enseignants,setEnseignants]=useState([])
    const [classes,setClasses]=useState([])
    const [my_domaine,setMy_domaine]=useState("")
    const search=nom+' '+ postnom+' '+prenom
    const [status_code,setStatus_code]=useState()
    const [error_submission,setError_submission]=useState(false)
    const csrf=()=>axios.get('sanctum/csrf-cookie')
    const [HandleSubmit_status, setHandleSubmit_status] = useState(false)
    const [submission,setSubmission]=useState(false)
    useEffect(()=>{
        handleRequest()
        handle_classe_request()
    },[])
    function handleMouse(e){

        e.target.textContent="Bonjour"
    }
    function handleMouseleave(e){
        e.target.textContent="Soumettre"
    }
    function handlekeyUpgain(e){
    
        const elementss=e.nextElementSibling;
      
    }
    function handleclick(){
        alert('You have clicked me')
    }
      const handleEmailChange = (e) => {
    setEmail(e.target.value.toLowerCase());
    
    // Nettoie dynamiquement l'erreur de l'email dès que l'utilisateur tape
    if (errors.email) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: null, // Supprime l'erreur spécifique à l'email
      }));
    }
  };
  
    const handle_classe_request=async()=>{
        try{
            await axios.post('api/classes_getter',{idecole:user?.ecole?.id}).then((res)=>{

                setClasses(res.data.items)
            })
        }
        catch(e){

        }
    }
    const HandleSubmit=async ()=>{
        setHandleSubmit_status(true)    
        if(nom !="" && postnom !="" && sexe!="" && date_naissance!="" && lieu_naissance!="" && adresse!=""){
            await axios.post('api/eleves',{nom:nom.toLowerCase(),postnom:postnom.toLowerCase(),prenom:prenom.toLowerCase(),sexe:sexe,adresse:adresse.toLowerCase(),lieu_naissance:lieu_naissance.toLowerCase(),date_naissance:date_naissance,niveau:niveau,nom_complet:nom_complet.toLowerCase(),domaine:my_domaine,idecole:user?.ecole?.id,type_transact:"enseignant",date_engagement:date_engagement,telephone:telephone,type_compte:"Enseignant",email:email}).then((res)=>{
           setMessage(res?.data?.message)
           setHandleSubmit_status(false)
                setNom("")
            setPostnom("")
            setPrenom("") 
            setSexe("")
            setAdresse("")
            setDate_naissance("")
            setLieu_naissance("")
            setNom_complet("")
            setNiveau("")
            setSubmission(true)
            setError_submission(false)

             
        }).catch((err)=>{
                setHandleSubmit_status(false)
                setErrors(err.response.data.errors)

                
        })
        }
        else{
            setError_submission(true)
            setSubmission(false)
            setHandleSubmit_status(false)

        }
    
       //alert("i want to submit your form don't be worry")
    }
    const handleRequest=async()=>{
      
        await axios.post('api/getenseignants').then((res)=>{
            setEnseignants(res.data.items)
            setStatus_code(res.data.status_code)
        }).catch((err)=>{
            console.log(err)
        })
    }
    
    return(
    <>
    <Formulaire title="Ajouter un enseignant" HandleSubmit_status={HandleSubmit_status} handleEmailChange={handleEmailChange} type="insertion" errors={errors} setErrors={setErrors} message={message} onclick={handleclick} email={email} setEmail={setEmail} date_engagement={date_engagement} setDate_engagement={setDate_engagement} telephone={telephone} setTelephone={setTelephone}  my_domaine={my_domaine} setMy_domaine={setMy_domaine} error_submission={error_submission} submission={submission} setNom={setNom} handlekeyUpgain={handlekeyUpgain} setPostnom={setPostnom} setPrenom={setPrenom} setSexe={setSexe} setDate_naissance={setDate_naissance} setLieu_naissance={setLieu_naissance} nom={nom} postnom={postnom} prenom={prenom} sexe={sexe} date_naissance={date_naissance} lieu_naissance={lieu_naissance} handleMouse={handleMouse} Count={Count} setCount={setCount} handleMouseleave={handleMouseleave} HandleSubmit={HandleSubmit} setNiveau={setNiveau} niveau={niveau} adresse={adresse} setAdresse={setAdresse} setNom_complet={setNom_complet} >
    <div className="col-md-6 mb-4">
        <div class="form-outline">
            <label class="form-label" for="firstName">NOM COMPLET</label>
            <input type="text"  class="form-control form-control-lg"  name="nom_complet" value={nom_complet} />                          
        </div>
    </div>
    </Formulaire>
    </>
    )
}
export default Insertion